import { apiGet, apiPost } from './index'

export type ConsolidationEntry = {
  id: number
  user_id: number
  status: string
  requested_at: string
  responded_at: string | null
  expires_at: string | null
  display_name: string
  email: string
}

export type ConsolidationListResponse = {
  consolidations: ConsolidationEntry[]
}

export type ConsolidationTriggerResponse = {
  created: number
  skipped: number
}

export function getStationConsolidations(stationId: number): Promise<ConsolidationListResponse> {
  return apiGet<ConsolidationListResponse>(`stations/${stationId}/consolidations`)
}

export function triggerStationConsolidations(stationId: number): Promise<ConsolidationTriggerResponse> {
  return apiPost<ConsolidationTriggerResponse>(`stations/${stationId}/consolidations`, {
    station_id: stationId,
  })
}

export function acceptConsolidation(token: string): Promise<{ status: string; stripe_subscription_id?: string }> {
  return apiPost<{ status: string; stripe_subscription_id?: string }>('consolidations/accept', {
    token,
  })
}
